import { render, staticRenderFns } from "./profile-table.vue?vue&type=template&id=e9001f8e&scoped=true&"
import script from "./profile-table.ts?vue&type=script&lang=ts&"
export * from "./profile-table.ts?vue&type=script&lang=ts&"
import style0 from "./profile-table.scss?vue&type=style&index=0&id=e9001f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9001f8e",
  null
  
)

export default component.exports